import { ICookies } from "../interfaces/cookies.interface";
import showdown from "showdown";

export const setCookie = (
    name: any,
    value: any,
    hours?: any,
    path = "/",
    domain?: any,
    secure?: any
) => {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (hours !== undefined || hours !== null) {
        let date = new Date();
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        cookieString += `; expires=${date.toUTCString()}`;
    }

    cookieString += `; path=${path}`;

    if (domain) {
        cookieString += `; domain=${domain}`;
    }

    if (secure) {
        cookieString += `; secure`;
    }

    document.cookie = cookieString;
};

export const getCookies = (): ICookies => {
    let cookies = document.cookie;
    let cookieArray = cookies.split(";");
    let cookieObject = {};

    cookieArray.forEach((cookie) => {
        let [name, value] = cookie.split("=");
        name = name.trim();
        value = value ? value.trim() : "";
        Object.assign(cookieObject, {
            ...cookieObject,
            [name]: decodeURIComponent(value)
        });
    });

    return cookieObject;
};

export const clearCookies = (): ICookies => {
    let cookies = document.cookie;
    let cookieArray = cookies.split(";");
    let cookieObject = {};

    cookieArray.forEach((cookie) => {
        let [name] = cookie.split("=");
        name = name.trim();
        setCookie(name, null, 0);
    });

    return cookieObject;
};

export const markdownToHtml = (markdown: string) => {

    const converter = new showdown.Converter({ simpleLineBreaks: true, strikethrough: true });
    
    return converter.makeHtml(markdown);
};

export const delay = async (time: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(() => resolve(), time));
};

interface IDateParts {
    YYYY: string;
    M: string;
    MM: string;
    d: string;
    dd: string;
    HH: string;
    mm: string;
    ms: string;
    [key: string]: string;
}

export const getDateParts = (date: string | Date, locale = "pt-PT"): IDateParts => {
    let d: Date;

    if (typeof date === "string") {
        d = new Date(date);
    } else {
        d = date;
    }

    const month = d.getUTCMonth() + 1;
    const day = d.getUTCDate();
    const hour = d.getUTCHours();
    const minutes = d.getUTCMinutes();
    const seconds = d.getUTCSeconds();
    const milliseconds = d.getUTCMilliseconds();

    return {
        YYYY: `${d.getFullYear()}`,
        dd: day < 10 ? `0${day}` : `${day}`,
        d: `${day}`,
        HH: hour < 10 ? `0${hour}` : `${hour}`,
        mm: minutes < 10 ? `0${minutes}` : `${minutes}`,
        ss: seconds < 10 ? `0${seconds}` : `${seconds}`,
        ms: milliseconds < 10 ? `0${milliseconds}` : `${milliseconds}`,
        MMMM: new Intl.DateTimeFormat(locale, { month: "long" }).format(d),
        MM: month < 10 ? `0${month}` : `${month}`,
        M: `${month}`
    };
};

export const formatDate = (date: string | Date, format: string, locale?: string) => {
    const dateParts = getDateParts(date, locale);

    let formatArray = format;

    Object.keys(dateParts).forEach((k) => {
        formatArray = formatArray.replaceAll(k, dateParts[k]);
    });

    return formatArray;
};

export const secondsToTimeFormat = (sec: number) => {
    return `${Math.floor(sec / 60) < 10 ? "0" + Math.floor(sec / 60) : Math.floor(sec / 60)}:${Math.floor(sec % 60) < 10 ? "0" + Math.floor(sec % 60) : Math.floor(sec % 60)}`;
};

export const getFromattedPath = (template: string, values: any) => {
    return template.replace(/:([a-zA-Z0-9_]+)/g, (match, key) => {
        return values[key] || match;
    });
};

export const handleFileDownload = async (url: string, name?: string) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const file_url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = file_url;
    a.download = name ?? "";
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const formatTemplate = (template: string, values: string[]) => {
    return template.replace(/\{(\d+)\}/g, (match, index) => {
        return typeof values[index] !== "undefined" ? values[index] : match;
    });
};
